var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3828 5.10156C13.4531 4.86719 13.5 4.63281 13.5 4.375C13.5 2.94531 12.3047 1.75 10.875 1.75C10.4766 1.75 10.1016 1.84375 9.75 2.00781C9 0.953125 7.75781 0.25 6.375 0.25C4.14844 0.25 2.34375 2.00781 2.25 4.21094C0.914062 4.67969 0 5.94531 0 7.375C0 9.25 1.5 10.75 3.375 10.75H12C13.6406 10.75 15 9.41406 15 7.75C15 6.64844 14.3906 5.64062 13.3828 5.10156ZM12 10H3.375C1.92188 10 0.75 8.82812 0.75 7.375C0.75 6.0625 1.73438 4.96094 3.02344 4.77344C3 4.65625 3 4.51562 3 4.375C3 2.52344 4.5 1 6.375 1C7.78125 1 8.97656 1.86719 9.49219 3.10938C9.84375 2.73438 10.3125 2.5 10.875 2.5C11.9062 2.5 12.75 3.34375 12.75 4.375C12.75 4.82031 12.5859 5.21875 12.3516 5.54688C13.4297 5.71094 14.25 6.64844 14.25 7.75C14.25 8.99219 13.2422 10 12 10ZM9.49219 5.47656C9.375 5.35938 9.1875 5.35938 9.09375 5.47656L7.5 7.07031V3.53125C7.5 3.39062 7.35938 3.25 7.21875 3.25H7.03125C6.86719 3.25 6.75 3.39062 6.75 3.53125V7.07031L5.13281 5.47656C5.03906 5.35938 4.85156 5.35938 4.73438 5.47656L4.61719 5.61719C4.5 5.71094 4.5 5.89844 4.61719 6.01562L6.91406 8.3125C7.03125 8.42969 7.19531 8.42969 7.3125 8.3125L9.60938 6.01562C9.72656 5.89844 9.72656 5.71094 9.60938 5.61719L9.49219 5.47656Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudArrowDown);
export default __webpack_public_path__ + "static/media/cloud-arrow-down.8894223d.svg";
export { ForwardRef as ReactComponent };